import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-chektemplate',
  templateUrl: './chektemplate.page.html',
  styleUrls: ['./chektemplate.page.scss'],
})
export class ChektemplatePage implements OnInit {

  category: any = '';
  templates: any = [];
  selectedArray: any = [];

  constructor(
    private userServ: UserService,
    private navParams: NavParams,
    private modalCtrl: ModalController
  ) {
    if (this.navParams.get('templatecate')) {
      this.category = this.navParams.get('templatecate');
      console.log(this.category);
    }
  }

  async ngOnInit() {
    this.templates = await this.userServ.getqrTemplates(this.category);
    console.log(this.templates);
  }
  async closeModal() {
    await this.modalCtrl.dismiss({});
  }
  async templatedata(data: any) {
    await this.modalCtrl.dismiss({ data });
  }
  async submitform() {
    console.log(this.templates);
    let templateText = '';
    this.templates.forEach(template => {
      if (template.isChecked) {
        templateText += template.template_text + '\n'
      }
    });
    console.log(templateText);
    await this.modalCtrl.dismiss({ data: templateText });
  }

}
